import React, { useState } from "react";

export default function TooltipLabel({
  children,
  helpText,
  htmlFor,
  className = "",
}) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="relative inline-flex items-center"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <label
        htmlFor={htmlFor}
        className={`block text-sm font-medium text-gray-700 cursor-help ${className}`}
      >
        {children}
      </label>

      <span className="ml-1 text-xs text-white bg-gray-500 rounded-full px-1">?</span>

      {open && (
        <div className="absolute z-50 top-full left-0 mt-1 w-64 rounded-md bg-gray-900 text-white text-xs p-3 shadow-lg">
          {helpText}
          <div className="absolute -top-1 left-3 w-2 h-2 bg-gray-900 rotate-45" />
        </div>
      )}
    </div>
  );
}
